export default "__VITE_ASSET__Bt$YITU___"